module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/helpers/isNaN.js
// module id = 448
// module chunks = 0